import { NavLink, useNavigate } from "react-router-dom";
import { Fingerprint, LogOut, User, X, AlertCircle, CalendarOff, Lock } from "lucide-react";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const menuItems = [
  { path: "/empleados/fichar",      label: "Fichar",          icon: <Fingerprint size={18} /> },
  { path: "/empleados/perfil",      label: "Editar perfil",   icon: <User size={18} /> },
  { path: "/empleados/incidencias", label: "Mis incidencias", icon: <AlertCircle size={18} /> },
  { path: "/empleados/ausencias",   label: "Mis ausencias",   icon: <CalendarOff size={18} /> },
];

export default function EmpleadoSidebar({ onClose, subscribed, isOpen }) {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    onClose?.();
    navigate("/");
  };

  return (
    <aside className={`tn-sidebar${isOpen ? " open" : ""}`}>
      <NavLink to="/" className="tn-sidebar__brand">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#FF7A00" class="bi bi-clock-history me-2 align-middle" viewBox="0 0 16 16"><path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z"></path><path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z"></path></svg>
        <span className="tn-sidebar__brand-name">Turnora</span>
        {onClose && (
          <button
            className="tn-close ms-auto"
            style={{ background: "rgba(255,255,255,.08)", color: "#fff" }}
            onClick={onClose}
          >
            <X size={16} />
          </button>
        )}
      </NavLink>

      <nav className="tn-sidebar__nav">
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1, color: "rgba(255,255,255,.25)", marginBottom: 8, paddingLeft: 14, textTransform: "uppercase", color: "white" }}>
          {subscribed ? "Mi área" : "Acceso restringido"}
        </div>

        {subscribed ? (
          menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `tn-nav-item ${isActive ? "active" : ""}`}
              onClick={onClose}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))
        ) : (
          menuItems.map((item) => (
            <div
              key={item.path}
              className="tn-nav-item"
              style={{ opacity: 0.3, cursor: "not-allowed", pointerEvents: "none" }}
              title="Suscripción requerida"
            >
              {item.icon}
              <span>{item.label}</span>
              <Lock size={12} style={{ marginLeft: "auto", opacity: 0.7 }} />
            </div>
          ))
        )}
      </nav>

      <div className="tn-sidebar__footer">
        <button className="tn-nav-item w-100" onClick={handleLogout}>
          <LogOut size={18} />
          <span>Cerrar sesión</span>
        </button>
        <p className="tn-sidebar__version">Turnora v0.1</p>
      </div>
    </aside>
  );
}
